import CapabilityMap from './CapabilityMap';

export default CapabilityMap;